export class WidgetLayout {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "row",
            "baseName": "row",
            "type": "number",
            "format": ""
        },
        {
            "name": "col",
            "baseName": "col",
            "type": "number",
            "format": ""
        },
        {
            "name": "rowSpan",
            "baseName": "rowSpan",
            "type": "number",
            "format": ""
        },
        {
            "name": "colSpan",
            "baseName": "colSpan",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WidgetLayout.attributeTypeMap;
    }
    constructor() {
    }
}
